import { OrganismeProjection, useGetOrganismeQuery } from "@common/services";

export function useOfaStatut({ id }) {
  const { data: organisme, isLoading } = useGetOrganismeQuery({
    id,
    projection: OrganismeProjection.STATUT
  }, { skip: !id });
  return { statut: organisme?.statut, isLoading }
}